import 'core-js/stable'
import 'regenerator-runtime/runtime'

import 'whatwg-fetch'

import moment from 'moment'
import 'moment/locale/de'
import 'moment/locale/de-at'
import 'moment/locale/es'
import 'moment/locale/pl'
import 'moment/locale/en-gb'
import 'moment/locale/en-ca'
import 'moment/locale/en-au'

import './styles/bootstrap/superflat/less/app.less'
import './styles/kanboIcons.css'
import './styles/sweetalert2.css'
import './styles/core.scss'
import 'react-image-crop/dist/ReactCrop.css'

import React from 'react'
import ReactDOM from 'react-dom'
import createPreserveQueryHistory from './createPreserveQueryHistory'
import KanBoApi from 'api/Api'
import { setNoConnection } from 'store/redux/layout'
import { runSaga } from 'store/sagaMiddleware'
import { init as initSaga } from 'store/sagas'
import { CHANNEL_DATA } from 'CHANNEL_DATA'

window.moment = moment

if (process.env.NODE_ENV === 'production') {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then(registrations => {
      for (const registration of registrations) {
        registration.unregister()
      }
    })
  }
}

export const PUSH = 'REDUX_ROUTER_HELPER_PUSH'

export const PUSH_CARD = 'REDUX_ROUTER_HELPER_PUSH_CARD'

export function push (...args) {
  return {
    type: PUSH,
    payload: args
  }
}

export function pushCard (cardId) {
  return {
    type: PUSH_CARD,
    payload: {
      cardId,
    }
  }
}

const connectStoreToApi = (store) => {
  KanBoApi.onChannelData = (channelData) => {
    store.dispatch({
      type: CHANNEL_DATA,
      payload: {
        channel: channelData.channel,
        actionName: channelData.actionName,
        elementName: channelData.elementName,
        data: channelData.data,
      }
    })
  }

  KanBoApi.onDisconnected = () => {
    store.dispatch(setNoConnection({
      noConnection: true
    }))
  }

  KanBoApi.onReconnected = () => {
    store.dispatch(setNoConnection({
      noConnection: false
    }))
    runSaga(initSaga)
  }
}

KanBoApi.connect().then(() => {
  const MOUNT_ELEMENT = document.getElementById('root')

  const history = createPreserveQueryHistory(['embed'])

  const createStore = require('./store/createStore').default

  const { store, persistor } = createStore(window.__INITIAL_STATE__, history)

  connectStoreToApi(store)

  const _render = () => {
    const App = require('./components/App').default
    ReactDOM.render(<App store={store} persistor={persistor} history={history} />, MOUNT_ELEMENT)
  }

  const renderApp = () => {
    if (!global.Intl) {
      import('intl').then(() => _render())
    } else {
      _render()
    }
  }

  // Enable HMR and catch runtime errors in RedBox
  // This code is excluded from production bundle
  if (process.env.NODE_ENV === 'development' && module.hot) {
    module.hot.accept(['./index'], () => renderApp())
  }

  renderApp()
})
